<div class="icon-div"><i class="fa close-icon fa-times-circle" (click)="delete()"></i></div>
<div class="modal-header pt-4 pl-4 mb-0 border-0 modal-text">
  <h4 class="modal-text">{{modalText}}</h4>
</div>
<p class="revert mb-0 modal-text modal-body" [innerHtml]="modcontent"></p>
<div class="modal-body p-0 modal-text">
</div>
<div class="modal-footer mt-0">  
  <button type="button" class="btn btn-primary buttonModal" (click)="delete()" [ngClass]="[localDriverBtn ===true || reportTile === true ? 'display-block'  : 'display-none']">OK</button>
</div>